import { QueryParams } from 'common/urls/QueryParams';
import { Slugs } from 'common/urls/Slugs';
import { ISegmentMetrics } from 'src/pages/consumer/explore/SegmentAnalytics';
import { Routes } from 'src/shared/Routes';
import { getSluggedPath } from 'src/shared/utils/RouteUtilities';

export const getShefPreviewPath = (
  shefId: string,
  activeDateFilters: string[],
  shefIndex: number, // Index the shef is being shown in the current cuisine,
  segmentMetrics?: ISegmentMetrics
): string => {
  const queryParams = {
    [QueryParams.RANK]: shefIndex,
    [QueryParams.DATE]: activeDateFilters,
    ...(segmentMetrics && {
      [QueryParams.EXPLORE_SEGMENT_ID]: segmentMetrics.esid,
      [QueryParams.EXPLORE_SEGMENT_POS]: segmentMetrics.pos,
      [QueryParams.EXPLORE_SEGMENT_RENDERED_ITEMS]: segmentMetrics.renderedItems,
      [QueryParams.EXPLORE_SEGMENT_TOTAL_ITEMS]: segmentMetrics.totalItems,
    }),
  };

  const route = Routes.CONSUMER_ORDER_ONE_TIME;
  return getSluggedPath(route, [{ slug: Slugs.ID, value: shefId }], queryParams);
};
